import type { UserProfile } from '../types/api';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export async function fetchUserProfile(): Promise<UserProfile> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/me`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<UserProfile>;
}
